import { useContext } from 'react';
import { Edit } from 'react-feather';
import { Card, CardBody, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { BILL_MANAGEMENT_CONST, ValidationLabel } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import LoaderResoinse from '../../loader/loader';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import { maxLengthCheck } from '../../utils/helper';

const BillManagementAddModel = (props) => {
  const { onSubmit, close, error } = props;
  const { modal, togglesubmit, formData, setFormData } = useContext(BillManagementContext);

  const { loaderShow } = useContext(OrganizationContext);
  const handelChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
  };

  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={() => close()}>
        {loaderShow === true && <LoaderResoinse />}
        <ModalHeader toggle={() => close()}>
          {togglesubmit ? (
            <span>{BILL_MANAGEMENT_CONST.ADD_BILL_MANAGEMENT}</span>
          ) : (
            <span>
              {BILL_MANAGEMENT_CONST.EDIT_BILL_MANAGEMENT} <span> </span>{' '}
              <Edit style={{ width: '50px', height: '20px', color: '#7366ff' }} />
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="12 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && formData.name?.length <= 0 ? 'validation' : 'non-validation'}
                        >
                          {error && formData.name?.length <= 0 ? ValidationLabel.nameRequired : ValidationLabel.name}
                        </Label>
                        <Input
                          className={`${error && formData.name?.length <= 0 ? 'inputValidation' : ''} "form-control`}
                          name="name"
                          type="text"
                          placeholder="Name"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={formData.name}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom01" className={'non-validation'}>
                          {'Contact No'}
                        </Label>
                        <Input
                          className={`${error && formData.phone?.length <= 0 ? 'inputValidation' : ''} "form-control`}
                          name="phone"
                          type="number"
                          placeholder="Name"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={formData.phone}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          maxLength={10}
                          onInput={maxLengthCheck}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Address'}</Label>
                        <textarea
                          className="form-control"
                          name="address"
                          id="validationCustom09"
                          type="text"
                          placeholder="Address"
                          onChange={handelChange}
                          value={formData.address}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>

                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true ? 'disabled' : ''}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default BillManagementAddModel;
